/** Routes kid mode must not reach without parent access. */
export const KID_BLOCKED_PREFIXES = [
  '/bookmarks',
  '/learn',
  '/memorization',
  '/progress',
  '/notes',
  '/playlists',
] as const

const PARENT_ACCESS_KEY = 'qlearn:kid:parentAccess'

export function grantKidParentAccess(): void {
  try {
    sessionStorage.setItem(PARENT_ACCESS_KEY, '1')
  } catch {
    // ignore
  }
}

export function hasKidParentAccess(): boolean {
  try {
    return sessionStorage.getItem(PARENT_ACCESS_KEY) === '1'
  } catch {
    return false
  }
}

export function revokeKidParentAccess(): void {
  try {
    sessionStorage.removeItem(PARENT_ACCESS_KEY)
  } catch {
    // ignore
  }
}

/** Game types available in kid mode (must match GamesLauncher filter). */
const KID_ALLOWED_GAMES = new Set([
  'multiple-choice',
  'word-puzzle',
  'sequence',
])

/** True when kid mode should redirect away from `pathname`. */
export function isKidBlockedPath(pathname: string): boolean {
  // Kid mode enters the reader only from home tiles (/reader/:n).
  if (pathname === '/reader') {
    return true
  }
  if (pathname.startsWith('/settings')) {
    return !hasKidParentAccess()
  }
  const gameMatch = pathname.match(/^\/games\/([^/]+)/)
  if (gameMatch && !KID_ALLOWED_GAMES.has(gameMatch[1])) {
    return true
  }
  return KID_BLOCKED_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  )
}
